function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  transform: "rotate(54 69.5 88.993)",
  x: 44,
  y: 34.622,
  width: 51,
  height: 108.741,
  rx: 25.5
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  opacity: 0.51,
  transform: "rotate(54 59.5 125.24)",
  x: 34,
  y: 70.869,
  width: 51,
  height: 108.741,
  rx: 25.5
});

function SvgGlyph1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 158,
    viewBox: "0 0 129 158",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -10)",
    fill: "none",
    fillRule: "evenodd"
  }, _ref, _ref2, /*#__PURE__*/React.createElement("rect", {
    stroke: "#13ADC7",
    strokeWidth: 2,
    opacity: 0.714,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(54 89.5 52.746)",
    x: 65,
    y: -0.625,
    width: 49,
    height: 106.741,
    rx: 24.5
  })));
}

var ForwardRef = React.forwardRef(SvgGlyph1);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };